const exploreRoutes = [
  {
    path: '/explore/points-matrix',
    name: 'ExploreMatrix',
    component: () => import('./exploreMatrices/exploreMatrices.vue'),
    meta: {
      title: 'Points Matrix',
      requiresAuth: false,
    },
  },
  {
    path: '/explore/nexus',
    name: 'ExploreMatrixPlayMorePass',
    component: () => import('./exploreMatrices/exploreMatricesPlayMorePass.vue'),
    meta: {
      title: 'Explore Nexus Clubs',
      requiresAuth: false,
      noLayout: true,
    },
  },
];

export default exploreRoutes;
